// @ts-strict-ignore
import * as React from 'react';
import pick from 'lodash/pick';

import {SelectTheme} from 'common/components/select/constants';
import {StepSelection} from 'common/report/funnels/models/types';
import {useTranslation} from 'common/i18n/hooks';
import {RowLabelType} from 'common/query-builder/query-entry-section/types';
import {SelectReact} from 'common/components/select';

import {RangeSelection} from './types';
import {generateStepRanges} from './util';
import styles from './index.module.styl';

export type Props = {
  selected?: StepSelection;
  numSteps?: number;
  rowLabelType?: RowLabelType;
  label?: string;
  theme?: SelectTheme;
  tooltip?: string;
  disableAllSteps?: boolean;
  disabled?: boolean;
  onSelect?: (ev: {detail: RangeSelection}) => void;
};

export function StepRangeSelector(props: Props) {
  const i18n = useTranslation();
  const sections = [
    {
      items: generateStepRanges({
        entry: props.selected,
        steps: props.numSteps,
        rowLabelType: props.rowLabelType,
        disableAllSteps: props.disableAllSteps,
      }).map((item) => ({
        ...item,
        label: typeof item.label === `string` ? item.label : item.label(i18n),
        tooltip: item.tooltip
          ? {
              ...item.tooltip,
              text: typeof item.tooltip.text === `string` ? item.tooltip.text : item.tooltip?.text(i18n),
            }
          : null,
      })),
    },
  ];
  const handleChange = (ev) => {
    const item = pick(ev.detail.item.value, [`isEntireRange`, `range`]);

    props.onSelect?.({detail: item});
  };
  return (
    <div className={styles.container}>
      {props.label ? <div className={styles.label}>{props.label}</div> : null}
      <SelectReact
        className={styles.select}
        sections={sections}
        theme={props.theme}
        menuWidth={140}
        disabled={props.disabled}
        tooltip={props.tooltip && {text: props.tooltip}}
        onChange={handleChange}
      />
    </div>
  );
}
